module.constant('moment', moment)
    .constant('marked', marked);
